import React from 'react';
import { motion } from 'framer-motion';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface ChartSeriesToggleCardProps {
  label: string;
  icon: LucideIcon;
  color: string;
  checked: boolean;
  onClick: () => void;
  value?: string;
  className?: string;
}

const ChartSeriesToggleCard: React.FC<ChartSeriesToggleCardProps> = ({
  label,
  icon: Icon,
  color,
  checked,
  onClick,
  value,
  className = ''
}) => {
  return (
    <div
      className={`flex items-center justify-between p-2 rounded-lg border transition-all duration-200 ${className}`}
      style={{ 
        borderColor: checked ? color : '#e5e7eb',
        backgroundColor: checked ? `${hexToRgba(color, 0.1)}` : '#ffffff'
      }}
    >
      <div className="flex items-center gap-2">
        <div 
          className="w-6 h-6 rounded-md flex items-center justify-center"
          style={{ backgroundColor: color }}
        >
          <Icon className="w-3 h-3 text-white" />
        </div>
        <span className="font-medium text-gray-800 text-xs truncate">{label}</span>
      </div>
      
      {value && (
        <span className="text-xs font-semibold" style={{ color }}>
          {value}
        </span>
      )}
      
      <label className="cursor-pointer">
        <input 
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onClick}
        />
        <div 
          className="w-3 h-3 rounded-full border-2 flex items-center justify-center ml-1"
          style={{ borderColor: color }}
        >
          {checked && (
            <div 
              className="w-1.5 h-1.5 rounded-full"
              style={{ backgroundColor: color }}
            ></div>
          )}
        </div>
      </label>
    </div>
  );
};

// Helper function to convert hex color to rgba
function hexToRgba(hex: string, alpha: number = 1): string {
  // Remove the hash if it exists
  hex = hex.replace('#', '');
  
  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Return the rgba value
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default ChartSeriesToggleCard;